module.exports = __webpack_public_path__ + "static/img/zeta_template_05.db0e99a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeta_template_05.png
// module id = YvPP
// module chunks = 1